import React from "react";

/* eslint-disable max-len */
export default function HorizonNewIcon() {
	return (
		<svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 33 16" enableBackground="new 0 0 33 16" xmlSpace="preserve">
		<g>
			<path fill="#D1161B" d="M30,16H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h27c1.7,0,3,1.3,3,3v10C33,14.7,31.7,16,30,16z"/>
			<g>
				<path fill="#FFFFFF" d="M5,4h1.7L9,8.3L9.8,10h0.1C9.8,9.2,9.7,8.1,9.7,7.2V4h1.5v8.1H9.6L7.2,7.7L6.4,6H6.3
					c0.1,0.9,0.2,1.9,0.2,2.8v3.3H5V4z"/>
				<path fill="#FFFFFF" d="M13.2,4h5v1.4h-3.4v1.9h2.9v1.4h-2.9v2.2h3.5v1.4h-5.1V4z"/>
				<path fill="#FFFFFF" d="M19.2,4h1.7l0.6,4c0.1,0.9,0.3,1.7,0.4,2.6h0c0.2-0.9,0.3-1.7,0.5-2.6l0.9-4h1.4l0.9,4
					c0.2,0.8,0.3,1.7,0.5,2.6h0.1c0.1-0.9,0.2-1.7,0.4-2.6l0.6-4h1.6l-1.5,8.1h-2l-0.9-4c-0.1-0.6-0.3-1.3-0.4-1.9h0
					c-0.1,0.6-0.2,1.2-0.4,1.9l-0.9,4h-2L19.2,4z"/>
			</g>
		</g>
		</svg>
	);
}
